/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

/**
 * A message supplied to LiteLLM for the guarded model request.
 */
export type LiteLLMStructuredMessage = {
  content?: any | undefined;
  role: string;
};

/** @internal */
export type LiteLLMStructuredMessage$Outbound = {
  content?: any | undefined;
  role: string;
};

/** @internal */
export const LiteLLMStructuredMessage$outboundSchema: z.ZodMiniType<
  LiteLLMStructuredMessage$Outbound,
  LiteLLMStructuredMessage
> = z.object({
  content: z.optional(z.any()),
  role: z.string(),
});

export function liteLLMStructuredMessageToJSON(
  liteLLMStructuredMessage: LiteLLMStructuredMessage,
): string {
  return JSON.stringify(
    LiteLLMStructuredMessage$outboundSchema.parse(liteLLMStructuredMessage),
  );
}
